module.exports = __webpack_public_path__ + "static/img/bg_down.7cd2f5d1.png";